import React, { useEffect, useState } from "react";
import HomeworkLayout from "../../homework/component/layout";
import LeftWidget from "./components/LeftWidget";
import style from "./reviewLunWen.module.scss";
import QuestDanxuan from "../../homework/component/Rows/components/QuestDanxuan";
import QuestZhuguan from "../../homework/component/Rows/components/QuestZhuguan";
import Header from "../../../components/Header";
import useRequest from "../../../utils/useRequest";
import _ from "underscore";
import QuestDuoxuan from "../../homework/component/Rows/components/QuestDuoxuan";
import { Button, message, Modal, Row, Col, Spin } from "antd";
import { getCorrectState } from "../../homework/component/Rows/utils";
import {
    getCurrentTime,
    getExamInfo,
    getStudentExamPaperInfo,
    savePaperScore
} from "../../../service/exam";
import moment from "moment";
import { errorMessage } from "../../../service/service";
import useFileDownload from "../../../utils/useFileDownload";
import Editor from "components/Editor";
import useRequestFn from "../../../utils/useRequestFn";
import { useHistory } from "react-router-dom";

interface UrlParams {
    paperId: string;
    studentId: string;
    examId: string;
}

interface PageReviewThesisProps {
    match: { params: UrlParams };
}

export interface Answer {
    answerId: number;
    content: string;
    isRight: "0" | "1";
    isChoose: "0" | "1";
    stuAnswer: string;
}

export interface Topic {
    topicId: number;
    type: string;
    typescript: string;
    trunk: string;
    score: string;
    markScore: string;
    contentText: string;
    isRight: "0" | "1";
    answers: Answer[];
}

export default function PageReviewThesis({
    match: { params }
}: PageReviewThesisProps) {
    const { examId, paperId, studentId } = params;
    const history = useHistory();
    const [getExamPaperInfo, { loading, data }] = useRequestFn(
        getStudentExamPaperInfo
    );
    const [examInfo] = useRequest(() => getExamInfo(examId));
    const [currentTime] = useRequest(() => getCurrentTime());

    const [courseName, setCourseName] = useState("");
    const [stuName, setStuName] = useState("");
    const [homeworkTime, setHomeworkTime] = useState("");

    const [topicList, setTopicList] = useState<Topic[]>([]);
    const onQuestClick = useFileDownload(() => stuName);

    const [comments, setComments] = useState<
        { comment: string; topicId: number }[]
    >([]);

    useEffect(() => {
        getExamPaperInfo({ paperId, studentId });
    }, []);

    useEffect(() => {
        if (!data || !examInfo) return;
        setCourseName(examInfo.name);
        setStuName(data.studentName);
        setHomeworkTime(data.endTime);
        setTopicList(_.sortBy(data.topics, "type"));
        setComments(
            _.map(data.topics, topic => ({
                comment: topic.comment || "",
                topicId: topic.topicId
            }))
        );
    }, [data, examInfo]);

    const saveComment = (topicId: number) => {
        const comment = comments.find(
            comment => comment.topicId === topicId
        ) || { comment: "" };
        savePaperScore({
            paperId: params.paperId,
            studentId: params.studentId,
            topicId,
            examId,
            comment: comment.comment
        })
            .then(res => message.success("保存成功！"))
            .catch(e => message.error(errorMessage(e)));
    };

    const getComment = (topicId: number) => {
        const comment = comments.find(
            comment => comment.topicId === topicId
        ) || { comment: "" };
        return comment.comment;
    };

    const handleChangeScore = (score: number, topicId: number) => {
        if (!currentTime || !examInfo) {
            Modal.error({ content: "无法获取考试信息, 请刷新页面重试" });
            return;
        }

        if (moment(currentTime).isBefore(examInfo.endTime)) {
            Modal.error({ content: "考核时间结束之后才能给学员打分" });
            return;
        }

        savePaperScore({
            paperId: params.paperId,
            studentId: params.studentId,
            topicId,
            examId,
            score
        })
            .then(res => message.success("打分成功！"))
            .catch(e => message.error(errorMessage(e)));
        setTopicList(
            _.map(topicList, item => {
                if (item.topicId === topicId) {
                    item.markScore = score.toString();
                }
                return item;
            })
        );
    };

    const changeComment = (value: string, topicId: number) => {
        setComments(
            _.map(comments, comment => {
                if (comment.topicId === topicId) {
                    comment.comment = value;
                }
                return comment;
            })
        );
    };

    const goPrev = () => {
        if (!data?.preStudent) return;
        const { paperId, studentId } = data.preStudent;
        getExamPaperInfo({ paperId, studentId });
        history.replace(
            `/exam/thesis/review/detail/${examId}/${paperId}/${studentId}`
        );
    };

    const goNext = () => {
        if (!data?.nextStudent) return;
        const { paperId, studentId } = data.nextStudent;
        getExamPaperInfo({ paperId, studentId });
        history.replace(
            `/exam/thesis/review/detail/${examId}/${paperId}/${studentId}`
        );
    };

    return (
        <div>
            <Header />

            <HomeworkLayout
                left={
                    <LeftWidget
                        courseName={courseName}
                        stuName={stuName}
                        homeworkTime={homeworkTime}
                        list={topicList}
                    />
                }
                main={
                    <Spin spinning={loading} key={stuName + studentId}>
                        <div onClick={onQuestClick}>
                            {topicList.map((item, index) =>
                                parseInt(item.type) !== 4 ? (
                                    <div key={index} className={style.block}>
                                        <div className={style.header}>
                                            <b>
                                                {
                                                    [
                                                        "单选题",
                                                        "多选题",
                                                        "判断题"
                                                    ][parseInt(item.type) - 1]
                                                }
                                            </b>{" "}
                                            (本小题 {item.score} 分)
                                        </div>
                                        {parseInt(item.type) !== 2 ? (
                                            <QuestDanxuan
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        ) : (
                                            <QuestDuoxuan
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    2
                                                )}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <div key={index} className={style.block}>
                                        <QuestZhuguan
                                            haveComment={false}
                                            onChange={handleChangeScore}
                                            index={index}
                                            topicId={item.topicId}
                                            contentText={item.contentText}
                                            answers={item.answers}
                                            trunk={item.trunk}
                                            markScore={item.markScore}
                                            score={item.score}
                                        />
                                        <div className={style.comment}>
                                            <Row>
                                                <Col span={2}>评语：</Col>
                                                <Col span={22}>
                                                    <Editor
                                                        data={getComment(
                                                            item.topicId
                                                        )}
                                                        onChange={e =>
                                                            changeComment(
                                                                e,
                                                                item.topicId
                                                            )
                                                        }
                                                        onBlur={() =>
                                                            saveComment(
                                                                item.topicId
                                                            )
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )
                            )}

                            <div className={style.footer}>
                                <Button
                                    type="primary"
                                    onClick={() => window.history.back()}>
                                    返回
                                </Button>
                                {!data?.preStudent && (
                                    <span className={style.firstStu}>
                                        当前是第一位学生
                                    </span>
                                )}
                                {data?.preStudent && (
                                    <Button
                                        className={style.btnPrev}
                                        onClick={goPrev}>
                                        上一份
                                    </Button>
                                )}
                                {data?.nextStudent && (
                                    <Button
                                        className={style.btnNext}
                                        onClick={goNext}>
                                        下一份
                                    </Button>
                                )}
                                {!data?.nextStudent && (
                                    <span className={style.lastStu}>
                                        当前是最后一位学生
                                    </span>
                                )}
                            </div>
                        </div>
                    </Spin>
                }
            />
        </div>
    );
}
